module.exports = __webpack_public_path__ + "static/media/confirm-entry.679129a2.svg";